export default __webpack_public_path__ + "static/blob8-852ad3e0970da200727078cbff15bfc9.svg";